/** Shared UI bits for the Telegram deep-link panels (sign-in and profile linking). */

export const PRIMARY_BUTTON_CLASS =
  'flex w-full items-center justify-center gap-2 rounded-lg bg-accent px-6 py-4 font-semibold text-on-accent transition-all hover:opacity-90 disabled:opacity-50';
export const PRIMARY_BUTTON_STYLE = {
  background: 'linear-gradient(135deg, var(--color-accent) 0%, var(--color-accent-container) 100%)',
};

export function formatCountdown(ms: number): string {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

/** QR codes are for scanning with a second device; phones/tablets get only the button. */
export function canShowQrCode(): boolean {
  return typeof window === 'undefined' || !window.matchMedia('(pointer: coarse)').matches;
}

export function Spinner() {
  return (
    <svg className="animate-spin" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="3"
        fill="none"
        opacity="0.25"
      />
      <path
        d="M22 12a10 10 0 0 0-10-10"
        stroke="currentColor"
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}
